module.exports = __webpack_public_path__ + "static/img/Mark-Anderson.1c462c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mark-Anderson.jpg
// module id = mMtP
// module chunks = 1